import { Box, useMediaQuery, useTheme } from '@mui/material'
import { useSelector} from 'react-redux'
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom'
import { AuthSelector } from '../../store/auth'
import { BaseHeader } from '../headers'
import { Sidebar } from '../sidebar'
import {CurrentUserSelector} from "../../store/currentUser";
import { useEffect, useState } from 'react'

export const BaseLayout = () => {
    const theme = useTheme()
    const navigate = useNavigate()
    const location = useLocation()

    const mobileView = useMediaQuery(theme.breakpoints.down("md"))

    const [showSidebar, setShowSidebar] = useState(false)

    const isLoggedIn = useSelector(AuthSelector.isLoggedIn)
    const validSub = useSelector(AuthSelector.isSubscriptionValid)
    const tempPassword = useSelector(CurrentUserSelector.isTempPassword)


    useEffect(() => {
        const state = {
            state: {
                from: `${location.pathname}${location.search}`,
            },
        }
        if (!isLoggedIn) {
            navigate('/login', state)
        }
        if (isLoggedIn && tempPassword) {
            navigate('/resetuserpassword', state)
        }
    }, [isLoggedIn, tempPassword])

    if (!validSub) {
        return <Navigate to="/invalidSubscription" />
    }

    const toggleSidebar = (open: boolean) => {
        setShowSidebar(open)
    }

  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
        <BaseHeader mobileView={mobileView} toggleSidebar={toggleSidebar}/>
        <Sidebar
          mobileView={mobileView}
          showSidebar={showSidebar}
          toggleSidebar={toggleSidebar}/>
      </Box>

      <Box
        component="div"
        sx={{
          flexGrow: 1,
          display: 'flex',
          overflowY: 'auto',
          padding: `80px 28px 28px ${mobileView ? 28 : 296}px`,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}
